import { getListByApi, getDataByIdApi } from "./action"
import { URL_CONSTANTS } from "./urls";


export const getAllModules = (params: any) => 
    getListByApi(URL_CONSTANTS.getAllModule, params);


export const getRolesList = (params: any) => 
    getListByApi(URL_CONSTANTS.getRoles, params);
export const getAllRolesList = (params: any) => 
    getListByApi(URL_CONSTANTS.getallRoles, params);
export const getRoleAndAccess = (dataId: string | number) =>
     getDataByIdApi(URL_CONSTANTS.getRoleAndAccess, dataId);

// ------------------------------- Use
export const getUserList = (params: any) => 
    getListByApi(URL_CONSTANTS.getUserList, params);

export const getUserById = (dataId: string | number) => 
    getDataByIdApi(URL_CONSTANTS.userAccess, dataId)

// --------------------------- patient lookup -
export const getPatientLookup = (params: any) => 
    getListByApi(URL_CONSTANTS.getPatientLookup, params);

export const getPatientLookupById = (dataId: string | number) => 
    getDataByIdApi(URL_CONSTANTS.getPatientLookup, dataId)

export const getCountDetails = (params: any) => 
    getListByApi(URL_CONSTANTS.getCountDetails, params);

export const getAllergyById = (dataId: string | number, params?: any) => 
    getDataByIdApi(URL_CONSTANTS.getAllergy, dataId, params)

export const getImmuzationsById = (dataId: string | number, params?: any) => 
    getDataByIdApi(URL_CONSTANTS.getImmuzations, dataId, params)

export const getFacilitiesDetails = (params?: any) => 
    getListByApi(URL_CONSTANTS.getFacilities, params);

export const getPCCLocation = (params?: any) => 
    getListByApi(URL_CONSTANTS.getPCCLocation, params);

export const getSourceLocation = (params?: any) => 
    getListByApi(URL_CONSTANTS.getSourceLocation, params);

export const getVitalsHistory = (dataId: string | number, params?: any) =>
     getDataByIdApi(URL_CONSTANTS.getVitalsHistory, dataId, params);

export const getPatients = (dataId: string | number, params?: any) => 
    getDataByIdApi(URL_CONSTANTS.getVitalsHistory, dataId, params);

// ---------------------------------- note error 

export const getNotesErrorList = (params: any) => 
    getListByApi(URL_CONSTANTS.getNotesErrorList, params);
export const getNotesErrorListByError = (params: any) => 
    getListByApi(URL_CONSTANTS.getNotesErrorListByError, params);
export const getRemovedNotesList = (params: any) => 
    getListByApi(URL_CONSTANTS.getRemovedNotesList, params);
export const getNotesById = (params: any) => 
    getDataByIdApi(URL_CONSTANTS.updateNotesErrorList, params);
export const getLocationsList = (params?: any) => 
    getListByApi(URL_CONSTANTS.getLocationsList, params);
export const getSenderNameList = (params?: any) => 
    getListByApi(URL_CONSTANTS.getSenderNameList, params);
export const getNoteTypeList = (params?: any) => 
    getListByApi(URL_CONSTANTS.getNotesTypeList, params);
export const getOriginalPdfUrlNotesById = (params: any) => 
    getDataByIdApi(URL_CONSTANTS.originalPdfUrlNotesErrorList, params);
export const getMedicationById = (dataId: string | number, params: any) => 
    getDataByIdApi(URL_CONSTANTS.getMedication, dataId, params)

export const getObservationById = (dataId: string | number) => 
    getDataByIdApi(URL_CONSTANTS.getVitals, dataId)

export const getDetectedPatientListById = (dataId: string | number) => 
    getDataByIdApi(URL_CONSTANTS.detectedPatientList, dataId)


// ------------------------------- mapping  ---

export const getMappedLocationList = (params: any) => 
    getListByApi(URL_CONSTANTS.getMappedLocationList, params);
export const getMappedPatientList = (params: any) => 
    getListByApi(URL_CONSTANTS.mappedPatient, params);



// ---------------------------------- mapping notes type  ----

export const getMappingNotesTypeList = (params: any) =>
     getListByApi(URL_CONSTANTS.getMappingNotesType, params);

export const getCustomNotesTypeList = (params: any) =>
     getListByApi(URL_CONSTANTS.customNotesType, params);




// ---------------------------------- posting notes   ---

export const getAllCustomNoteType = () => 
    getListByApi(URL_CONSTANTS.getAllCustomNoteType);
export const getPatientIdList = (params: any) =>
    getListByApi(URL_CONSTANTS.getPatientSearch, params)
// export const getCustomNotesSectionById =(dataId: string | number )=> 
// getDataByIdApi(URL_CONSTANTS.getNotesSection,dataId)


// --------------------------- dashboard count  ---------
export const getDashboardCount = () =>
    getListByApi(URL_CONSTANTS.getDashboardCount);

// --------------------------------- Nursing Summary ---------------------

export const getNursingSummaryById = (dataId: string | number) =>
    getDataByIdApi(URL_CONSTANTS.nursingSummaryGetById, dataId);

export const getNursingSummaryHealth = () =>
    getListByApi(URL_CONSTANTS.nursingSummaryHealth);

// --------------------------------- eFax ---------------------

export const getEfaxList = (params: any) =>
    getListByApi(URL_CONSTANTS.efaxCurd, params);

// --------------------------------- Auto Delete ---------------------
export const getAutoDeleteConfigs = (params: any) =>
    getListByApi(URL_CONSTANTS.autoDeleteConfigs, params);

export const getAutoDeleteSchedule = () =>
    getListByApi(URL_CONSTANTS.autoDeleteSchedule);
